import {nanoid} from "nanoid"

import App from "@frog/source/models/App.js"
import World from "@frog/source/models/World.js"
import Stage from "@frog/source/models/Stage.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import bookScripts from "../scripts.js"

export default {
    "slug": "X",
    "stage": {
        "images": [
            // ..
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
            "width": 64,
            "height": 32,
        }),
        "hud": require("../hud.jsx").default,
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    {"func": () => {
                        console.log("hello")
                    }},
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({
                        "spotTag": "spawn",
                        "defaultPartyUnitKeys": ["ashe"]
                    }),
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawn-monster",
                        "protounit": {
                            "key": "monster",
                            //
                            "randomJobKey": "book/mothman, book/ghost, book/ooze, book/werewolf, book/vampire, book/mothman, book/eyebeast, book/demon, book/angel, book/undead",
                        }
                    })
                ]
            },
            ...bookScripts(),
        ]
    },
}
